var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGamma = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 113 21",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6.673 2.426a9.3 9.3 0 0 0-3.406 3.326A8.76 8.76 0 0 0 2 10.336c0 1.644.426 3.189 1.257 4.585a9.3 9.3 0 0 0 3.406 3.326c1.426.812 3.01 1.228 4.723 1.228h6.911V8.336h-8.02v3.872h3.782v3.148h-2.534a4.75 4.75 0 0 1-2.495-.683 5.23 5.23 0 0 1-1.812-1.822 4.9 4.9 0 0 1-.664-2.505c0-.9.228-1.752.664-2.505A5 5 0 0 1 9.03 6.02a4.75 4.75 0 0 1 2.495-.684h6.782V1.198h-6.911c-1.713 0-3.297.416-4.723 1.228"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gamma_svg__paint0_linear_1743_89)",
  d: "M6.673 2.426a9.3 9.3 0 0 0-3.406 3.326A8.76 8.76 0 0 0 2 10.336c0 1.644.426 3.189 1.257 4.585a9.3 9.3 0 0 0 3.406 3.326c1.426.812 3.01 1.228 4.723 1.228h6.911V8.336h-8.02v3.872h3.782v3.148h-2.534a4.75 4.75 0 0 1-2.495-.683 5.23 5.23 0 0 1-1.812-1.822 4.9 4.9 0 0 1-.664-2.505c0-.9.228-1.752.664-2.505A5 5 0 0 1 9.03 6.02a4.75 4.75 0 0 1 2.495-.684h6.782V1.198h-6.911c-1.713 0-3.297.416-4.723 1.228"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M28.493 1.02c-4.228 0-7.663 3.446-7.663 7.683v10.773h4.158V14.07h7.01v5.406h4.158V8.703c0-4.237-3.435-7.683-7.663-7.683m3.505 9.188h-7.01V8.693a3.514 3.514 0 0 1 3.505-3.515 3.514 3.514 0 0 1 3.505 3.515z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gamma_svg__paint1_linear_1743_89)",
  d: "M28.493 1.02c-4.228 0-7.663 3.446-7.663 7.683v10.773h4.158V14.07h7.01v5.406h4.158V8.703c0-4.237-3.435-7.683-7.663-7.683m3.505 9.188h-7.01V8.693a3.514 3.514 0 0 1 3.505-3.515 3.514 3.514 0 0 1 3.505 3.515z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M59.07 1c-3.179 0-5.763 2.594-5.763 5.782v7.347a1.55 1.55 0 0 1-1.555 1.554 1.55 1.55 0 0 1-1.554-1.554V6.792c0-3.188-2.584-5.782-5.762-5.782s-5.763 2.594-5.763 5.782v12.693h4.218V6.792a1.55 1.55 0 0 1 1.555-1.554A1.55 1.55 0 0 1 46 6.792v7.337c0 3.188 2.584 5.782 5.763 5.782s5.762-2.594 5.762-5.782V6.782a1.55 1.55 0 0 1 1.554-1.554 1.55 1.55 0 0 1 1.555 1.554v12.703h4.218V6.782C64.852 3.594 62.267 1 59.089 1z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gamma_svg__paint2_linear_1743_89)",
  d: "M59.07 1c-3.179 0-5.763 2.594-5.763 5.782v7.347a1.55 1.55 0 0 1-1.555 1.554 1.55 1.55 0 0 1-1.554-1.554V6.792c0-3.188-2.584-5.782-5.762-5.782s-5.763 2.594-5.763 5.782v12.693h4.218V6.792a1.55 1.55 0 0 1 1.555-1.554A1.55 1.55 0 0 1 46 6.792v7.337c0 3.188 2.584 5.782 5.763 5.782s5.762-2.594 5.762-5.782V6.782a1.55 1.55 0 0 1 1.554-1.554 1.55 1.55 0 0 1 1.555 1.554v12.703h4.218V6.782C64.852 3.594 62.267 1 59.089 1z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M104.288 1.03c-4.228 0-7.663 3.445-7.663 7.683v10.772h4.158v-5.406h7.01v5.406h4.158V8.713c0-4.238-3.435-7.683-7.663-7.683m3.505 9.198h-7.01V8.713a3.513 3.513 0 0 1 3.505-3.515 3.513 3.513 0 0 1 3.505 3.515z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gamma_svg__paint3_linear_1743_89)",
  d: "M104.288 1.03c-4.228 0-7.663 3.445-7.663 7.683v10.772h4.158v-5.406h7.01v5.406h4.158V8.713c0-4.238-3.435-7.683-7.663-7.683m3.505 9.198h-7.01V8.713a3.513 3.513 0 0 1 3.505-3.515 3.513 3.513 0 0 1 3.505 3.515z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M88.338 1c-3.179 0-5.763 2.594-5.763 5.782v7.347a1.55 1.55 0 0 1-1.554 1.554 1.55 1.55 0 0 1-1.555-1.554V6.782C79.466 3.594 76.882 1 73.704 1s-5.762 2.594-5.762 5.782v12.703h4.217V6.782a1.55 1.55 0 0 1 1.555-1.554 1.55 1.55 0 0 1 1.554 1.554v7.347c0 3.188 2.584 5.782 5.763 5.782s5.762-2.594 5.762-5.782V6.782a1.55 1.55 0 0 1 1.554-1.554 1.55 1.55 0 0 1 1.555 1.554v12.703h4.218V6.782C94.12 3.594 91.536 1 88.357 1z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#gamma_svg__paint4_linear_1743_89)",
  d: "M88.338 1c-3.179 0-5.763 2.594-5.763 5.782v7.347a1.55 1.55 0 0 1-1.554 1.554 1.55 1.55 0 0 1-1.555-1.554V6.782C79.466 3.594 76.882 1 73.704 1s-5.762 2.594-5.762 5.782v12.703h4.217V6.782a1.55 1.55 0 0 1 1.555-1.554 1.55 1.55 0 0 1 1.554 1.554v7.347c0 3.188 2.584 5.782 5.763 5.782s5.762-2.594 5.762-5.782V6.782a1.55 1.55 0 0 1 1.554-1.554 1.55 1.55 0 0 1 1.555 1.554v12.703h4.218V6.782C94.12 3.594 91.536 1 88.357 1z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "gamma_svg__paint0_linear_1743_89",
  x1: 10.153,
  x2: 10.153,
  y1: 1.198,
  y2: 19.475,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gamma_svg__paint1_linear_1743_89",
  x1: 28.493,
  x2: 28.493,
  y1: 1.02,
  y2: 19.476,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gamma_svg__paint2_linear_1743_89",
  x1: 51.762,
  x2: 51.762,
  y1: 1,
  y2: 19.911,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gamma_svg__paint3_linear_1743_89",
  x1: 104.288,
  x2: 104.288,
  y1: 1.03,
  y2: 19.485,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gamma_svg__paint4_linear_1743_89",
  x1: 81.031,
  x2: 81.031,
  y1: 1,
  y2: 19.911,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGamma);
export default ForwardRef;